import { render, staticRenderFns } from "./MenuItemPrimary.vue?vue&type=template&id=5ae8fb30&scoped=true&"
import script from "./MenuItemPrimary.vue?vue&type=script&lang=js&"
export * from "./MenuItemPrimary.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemPrimary.vue?vue&type=style&index=0&id=5ae8fb30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8fb30",
  null
  
)

export default component.exports